<template>
  <section class="underwriting-refer">
    <div class="table">
      <div class="tr">
        <span>Position / Duties</span>
        <span>{{ getAllOptionName21('duties', quoteForm.duty_id) }}</span>
      </div>
      <div class="tr">
        <span>Nature</span>
        <span>{{ getAllOptionName21('nature', quoteForm.nature) }}</span>
      </div>
      <div class="tr">
        <span>Nationality</span>
        <span>{{ getAllOptionName21('nationality', quoteForm.nationality_id) }}</span>
      </div>
      <div class="tr">
        <span>Age</span>
        <span>{{ getAllOptionName21('domestic_age', quoteForm.domestic_age) }}</span>
      </div>
      <div class="tr">
        <span>Coverage</span>
        <span>{{ getAllOptionName21('coverage', quoteForm.coverage_id) }}</span>
      </div>
      <!--      <div class="tr">-->
      <!--        <span>Date of Birth</span>-->
      <!--        <span>{{ quoteForm.domestic_dob }}</span>-->
      <!--      </div>-->
      <div class="tr">
        <span>Monthly Salary</span>
        <span>{{ quoteForm.monthly_salary| formatMoney(2, true)  }}</span>
        <!--        <span>{{ getOptionName('', quoteForm.monthly_salary, salaryOptions) }}</span>-->
      </div>
      <div
        v-if="quoteForm.period_of_cvr"
        class="tr">
        <span>Period of Insurance</span>
        <span>{{ getAllOptionName21('period', quoteForm.period_of_cvr) }}</span>
      </div>
    </div>

    <template v-if="benefitsList && benefitsList.length > 0">
      <h3>More Benefits</h3>
      <div class="benefits-list">
        <span
          v-for="(item, index) in benefitsList"
          :key="index">
          {{ item }}
        </span>
      </div>
    </template>
  </section>
</template>
<script>
import { mapState } from 'vuex'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'

export default {
  name: 'UnderwritingRefer',
  mixins: [MixinOptions,MixinFormat],
  computed: {
    ...mapState('quote', ['quoteForm']),
    localAllOptions() {
      return this.allOptions21
    },
    isDoula() {
      const { duty_id } = this.quoteForm
      const data = this.getOptionData('', duty_id, this.localAllOptions.duties)
      const { doula } = data || {}
      return doula === 1
    },
    salaryOptions() {
      const { salary } = this.localAllOptions
      const { doula = [], others = [] } = salary || {}
      if(this.isDoula) {
        return doula
      }
      return others
    },
    benefitsList() {
      const { benefits = [] } = this.quoteForm
      if(!benefits) {
        return []
      }
      return benefits.reduce((result, item) => {
        result.push(
          this.getAllOptionName21('benefits', item)
        )
        return result
      }, [])
    }
  }
}
</script>
